'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from '@onclicks/sharedmobilei18n/routing'
import { useUser } from '@/kmsApp/providers/user-provider'
import { NavLink } from '../HeaderClient'

export const CompanySubmenuMobile = ({
  link,
  setMobileMenuOpen,
}: {
  link: NavLink
  setMobileMenuOpen: (isOpen: boolean) => void
}) => {
  const t = useTranslations('menu_page')
  const { me, selectEntreprise } = useUser()
  const router = useRouter()
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)

  const entreprises = me?.entreprisesDisponibles ?? []

  // `null` = à titre privé : les courses réservées ensuite ne relèvent d'aucune
  // entreprise (ni facture, ni tarif négocié, ni champ personnalisé).
  const handleSelect = async (idEntreprise: number | null) => {
    await selectEntreprise(idEntreprise)
    setIsSubmenuOpen(false)
    setMobileMenuOpen(false)
    router.refresh()
  }

  return (
    <div>
      <div
        className="flex items-center justify-end gap-2 py-2 cursor-pointer hover:bg-white/5 rounded"
        onClick={() => setIsSubmenuOpen(!isSubmenuOpen)}
      >
        <p>{link.label}</p>
        <span className={`transition-transform text-sm ${isSubmenuOpen ? 'rotate-180' : ''}`}>
          ▾
        </span>
      </div>

      {isSubmenuOpen && (
        <div className="pl-4 flex flex-col">
          {entreprises.map((entreprise) => (
            <div
              key={entreprise.id}
              onClick={() => handleSelect(entreprise.id)}
              className={`py-2 cursor-pointer hover:bg-white/5 rounded text-sm ${
                me?.entrepriseActive?.idEntreprise === entreprise.id ? 'font-bold' : 'font-normal'
              }`}
            >
              {entreprise.nom}
            </div>
          ))}

          <div aria-hidden="true" className="border-t border-white/15 my-1" />

          <div
            onClick={() => handleSelect(null)}
            className={`py-2 cursor-pointer hover:bg-white/5 rounded text-sm ${
              me?.entrepriseActive ? 'font-normal' : 'font-bold'
            }`}
          >
            {t('private_mode')}
          </div>
        </div>
      )}
    </div>
  )
}
